<template>
<div class="search_container searchArea">
    <el-form :inline="true" :model='searchInfo' ref="searchInfo" :rules="rules">
      <el-form-item v-if="!hiddenPhoneSearch" prop="phone" label="手机：">
        <el-input v-model="searchInfo.phone" @change="phoneChange" clearable></el-input>
      </el-form-item>
        <el-form-item v-if="!hiddenSearch" label="日期">
            <el-date-picker v-model="searchInfo.date" @change="dateChange" type="daterange" range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-button v-if="!hiddenSearch" type="primary" round @click="searchList()">查询</el-button>
            <el-button type="primary" round @click="exportData()">导出</el-button>
        </el-form-item>
    </el-form>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'

export default {
    name: 'searchItem',
    props: {
        searchInfo: {
            type: Object,
            required: true
        }

    },
    data() {
        return {
            rules: {},
            hiddenSearch: false,
            hiddenPhoneSearch: false
        }
    },
    computed: {},
    created() {},
    mounted(){
        console.log(this.$route)
        if (this.$route.name == 'bofangtongji'){
            this.hiddenSearch = true
        } else {
            this.hiddenSearch = false
        }
        if (this.$route.name == 'yonghutongji') {
          this.hiddenPhoneSearch = false
        } else {
          this.hiddenPhoneSearch = true
        }
    },
    methods: {
        // 查询
        searchList() {
            this.$emit('searchList', this.searchInfo)
        },
        exportData() {
            this.$emit('exportData', this.searchInfo)
        },
        dateChange(e){
            console.log(e)
            this.searchInfo.date = e
            this.$emit('update:searchInfo', this.searchInfo)
        },
        phoneChange(e) {
          console.log(e)
          this.searchInfo.phone = e
          this.$emit('update:searchInfo', this.searchInfo)
        }
    }
}
</script>

<style>
.search_container {
    padding: 40px 0 18px;
    border-bottom: 1px solid #eff1f4;
}

.el-date-editor .el-range-separator {
    padding: 0;
}
</style>
